import { WarmHandoffAnswers } from '@bariendo/lib/patient-access-warm-handoff-note';
import dayjs from 'dayjs';

/** The three lines that together make up the greeting. */
const GREET_KEYS = ['g_hi', 'g_check', 'g_purpose'];

function text(answers: WarmHandoffAnswers, id: string): string {
  const value = answers.values[id];
  return typeof value === 'string' ? value : '';
}

function list(answers: WarmHandoffAnswers, id: string): string[] {
  const value = answers.values[id];
  return Array.isArray(value) ? value : [];
}

/**
 * The one-line value a beat shows when collapsed. An empty string means the beat
 * is untouched, which is also what drives its tick.
 *
 * Distinct from the *card's* collapsed preview, which is the outcome alone — this
 * is per-row, inside an open card.
 */
export function summarizeWarmHandoffBeat(beatId: string, answers: WarmHandoffAnswers): string {
  switch (beatId) {
    case 'greet':
      // All three or nothing: a half-worked greeting is not worth a row value, and
      // the rep can see the checkboxes when it matters.
      return GREET_KEYS.every((key) => answers.values[key] === true) ? 'Done' : '';

    case 'timing': {
      if (answers.procedureDate) {
        const day = dayjs(answers.procedureDate.start);
        return day.isValid() ? day.format('ddd, MMM D') : answers.procedureDate.start;
      }
      // The decline chip lands in `values` rather than as a resolved date.
      return text(answers, 't_date');
    }

    case 'ready':
      return text(answers, 'r_pay');

    case 'notready': {
      const parts = [text(answers, 'n_when'), list(answers, 'n_why').join(', ')].filter(Boolean);
      return parts.join(' · ');
    }

    case 'close':
      return text(answers, 'close');

    default:
      return '';
  }
}
